import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { updateValueSection } from "../../api/apiValueSection";
import parseError from "../../utils/parseError";

export const useUpdateValueSection = () => {
    const queryClient = useQueryClient();
    const { i18n } = useTranslation();
    const isArabic = (i18n.language || "en").startsWith("ar");

    const mutation = useMutation({
        mutationFn: (data) => updateValueSection(data),
        onSuccess: (response) => {
            queryClient.invalidateQueries({ queryKey: ["value-section"] });
            toast.success(
                response?.message ||
                (isArabic ? "تم تحديث بيانات القيم" : "Value section updated")
            );
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || (isArabic ? "تعذر التحديث" : "Failed to update"));
        },
    });

    return mutation;
};
